import { render, staticRenderFns } from "./SlideTabs.vue?vue&type=template&id=cb98a342&scoped=true&"
import script from "./SlideTabs.vue?vue&type=script&lang=js&"
export * from "./SlideTabs.vue?vue&type=script&lang=js&"
import style0 from "./SlideTabs.vue?vue&type=style&index=0&id=cb98a342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb98a342",
  null
  
)

export default component.exports